<template>
    <div class="back-button">
        <div>
            <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M-3.93402e-07 8L9.75 0.205772L9.75 15.7942L-3.93402e-07 8Z" fill="#E0C522"/>
            </svg>
        </div>
        <div style="position: relative;" :style="{ top: locale == 'en' ? '1px' : '0px' }">
            {{ $t('specials.backButton') }}
        </div>
    </div>
</template>
<script>
import { useI18n } from 'vue-i18n';

export default {
    name: "UzhnetBackButton",

    setup() {
        const { locale } = useI18n();

        return {
            locale
        }
    }
}
</script>
